import achievements from './achievements'
import actionItems from './action_items'
import affiliations from './affiliations'
import applications from './applications'
import candidate from './candidate'
import chats from './chats'
import eligibilities from './eligibilities'
import experiences from './experiences'
import invites from './invites'
import languageProficiencies from './language_proficiencies'
import notifications from './notifications'
import opportunities from './opportunities'
import opportunityLocations from './opportunity_locations'
import profile from './profile'
import profileQualificationComponents from './profile_qualification_components'
import profileQualifications from './profile_qualifications'
import studyRights from './study_rights'
import workRights from './work_rights'

export default {
  namespaced: true,
  modules: {
    achievements,
    actionItems,
    affiliations,
    applications,
    candidate,
    chats,
    eligibilities,
    experiences,
    invites,
    languageProficiencies,
    notifications,
    opportunities,
    opportunityLocations,
    profile,
    profileQualificationComponents,
    profileQualifications,
    studyRights,
    workRights,
  },
}
